<div class="deactivate-dialog">
    <div class="mat-subheading-1">
        Change status?
    </div>
    <mat-dialog-content class="mat-body-2 content" >
        Are you sure you want to deactivate user account?
  </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button color="primary" (click)="onCancel()" mat-dialog-close>NO, GO BACK</button>
        <button mat-button color="primary"   (click)="onConfirm()">YES, CHANGE</button>
     </mat-dialog-actions>
</div>